import React, { useEffect, useState } from "react";
import GalleryView from "./GalleryView";
import AddToGalleryView from "./AddToGalleryView";
import EditImageView from "./EditImageView";
import { hasUserRole } from "../../../../utils/AuthUtils";
import Constants from "../../../../utils/Constants";

const GalleryWorkflow = function() {

  const Views = {
    Gallery: 1,
    AddImage: 2,
    EditImage: 3
  }

  const [currentView, setCurrentView] = useState(Views.Gallery);
  const [selectedImage, setSelectedImage] = useState(null);

  /**
   * Redners the view JSX based on the selected view.
   * @returns 
   */
  const renderView = () => {
    let viewJsx = null;

    switch (currentView) {
      case Views.Gallery:
        viewJsx = <GalleryView workflowViews={Views} setWorkflowView={setCurrentView} updateSelectedImage={setSelectedImage} />;
        break;

      case Views.AddImage:
        viewJsx = hasUserRole(Constants.UserRole.InventoryManager)
          ? <AddToGalleryView workflowViews={Views} setWorkflowView={setCurrentView} /> 
          : null
        ;
        break;

      case Views.EditImage:
        viewJsx = hasUserRole(Constants.UserRole.InventoryManager) 
          ? <EditImageView workflowViews={Views} setWorkflowView={setCurrentView} selectedImage={selectedImage} />
          : null
        ;
        break;
    }

    return viewJsx;
  }

  return renderView();
}

export default GalleryWorkflow; 